<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
			<el-form-item label="发票类型" prop="resource">
				<el-radio-group v-model="ruleForm.type" size="small" class="inpyabeb">
					<el-radio v-if="ruleForm.type==1" label="1">普通发票</el-radio>
					<el-radio v-if="ruleForm.type==2" label="2">专用发票</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="单位名称" prop="unit_name">
				<el-input v-model="ruleForm.unit_name" size="small" class="inpyabeb" placeholder="请输入单位名称"></el-input>
			</el-form-item>
			<el-form-item label="纳税人识别号" prop="taxpayer_identification_number">
				<el-input v-model="ruleForm.taxpayer_identification_number" size="small" class="inpyabeb"
					placeholder="请输入纳税人识别号"></el-input>
			</el-form-item>
			<el-form-item label="地址" prop="address">
				<el-input v-model="ruleForm.address" size="small" class="inpyabeb" placeholder="请输入单位地址"></el-input>
			</el-form-item>

			<el-form-item label="电话" prop="tel">
				<el-input v-model="ruleForm.tel" size="small" class="inpyabeb" placeholder="请输入联系电话"></el-input>
			</el-form-item>
			<el-form-item label="开户行名称" prop="account">
				<el-input v-model="ruleForm.account" size="small" class="inpyabeb" placeholder="请输入开户行名称"></el-input>
			</el-form-item>
			<el-form-item label="开票金额" prop="money">
				<el-input v-model="ruleForm.money" size="small" class="inpyabeb" placeholder="开票金额"></el-input>
			</el-form-item>
			<el-form-item label="接收邮箱" prop="mailbox">
				<el-input v-model="ruleForm.mailbox" size="small" class="inpyabeb" placeholder="请输入接收电子发票的邮箱地址">
				</el-input>
			</el-form-item>
			<div class="block-solid"></div>
			<el-form-item>
				<el-button type="primary" icon="el-icon-check" style="background-color:#194ABE"
					@click="submitForm('ruleForm')" size="small" class="block-submit margin-top-36">提交申请
				</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import {
		Invoice, //申请发票
	} from "../../utils/api.js"
	export default {
		name: "InvoiceFrom",
		props: ['step', 'resource', 'currItem'],

		data() {
			return {

				ruleForm: {
					type: this.resource,
					unit_name: '',
					taxpayer_identification_number: '',
					address: '',
					tel: '',
					account: '',
					money: '',
					mailbox: '',
				},
				rules: {
					unit_name: [{
						required: true,
						message: '请输入单位名称',
						trigger: 'blur'
					}],
					taxpayer_identification_number: [{
						required: true,
						message: '请输入纳税人识别号',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入单位地址',
						trigger: 'blur'
					}],
					tel: [{
						required: true,
						message: '请输入联系电话',
						trigger: 'blur'
					}],
					account: [{
						required: true,
						message: '请输入开户行名称',
						trigger: 'blur'
					}],
					money: [{
						required: true,
						message: '请输入开票金额',
						trigger: 'blur'
					}],
					mailbox: [{
						required: true,
						message: '请输入接收电子发票的邮箱地址',
						trigger: 'blur'
					}]
				}
			}
		},

		methods: {

			submitForm(formName) {
				console.log(this.currItem)
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.ruleForm.user_id = this.currItem[0].user_id
						console.log(this.ruleForm)
						// return
						Invoice(this.currItem[0].id, this.ruleForm).then(res => {
							console.log(res)
							this.$message({
								message: '申请成功',
								type: 'success'
							});
							this.$emit('changeStep', 3)
						}).catch(err => {
							this.$message.error(err);
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

		}
	}
</script>
<style>
	.el-form-item__content {
		text-align: left;
	}
</style>
<style scoped lang="less">
	.demo-ruleForm {
		width: 100%;
		margin: 30px 0;

		.inpyabeb {
			width: 50%;
		}
	}

	.margin-top-36 {
		margin-top: 36px;
	}

	.block-solid {
		width: 100%;
		height: 2px;
		background: #E51725;
		margin-top: 50px;
	}
</style>
